export type TableLayout = 'full' | 'split';

// A failed load shows no rows, even while the last good page is still cached.
export function tableRows<T>(rows: readonly T[], errorMessage: string | null): readonly T[] {
    return errorMessage ? [] : rows;
}

// The pane follows the selection only while its row is on screen; the selection itself is kept.
export function openPaneKey<T>(
    selectedKey: string | null,
    rows: readonly T[],
    getKey: (row: T) => string
): string | null {
    if (selectedKey === null) return null;
    return rows.some((row) => getKey(row) === selectedKey) ? selectedKey : null;
}

export function tableLayout(openKey: string | null): TableLayout {
    return openKey === null ? 'full' : 'split';
}

export interface SelectionPin {
    key: string | null;
    // The list (filters, sort, mode and page) on screen when that selection was made.
    listScope: string;
}

// A selection keeps its pane in the list it was made in, even when its row isn't there (a link to
// an order outside the default dates); changing the list then falls back to openPaneKey.
export function isSelectionPinned(
    pin: SelectionPin,
    selectedKey: string | null,
    listScope: string
): boolean {
    if (selectedKey === null) return false;
    return pin.key !== selectedKey || pin.listScope === listScope;
}

export function visiblePaneKey<T>(
    selectedKey: string | null,
    rows: readonly T[],
    getKey: (row: T) => string,
    pinned: boolean
): string | null {
    if (pinned) return selectedKey;
    return openPaneKey(selectedKey, rows, getKey);
}
